import { Subject } from 'rxjs';

export class ValidationErrors extends Array<ValidationError> {
	public changed$ = new Subject<void>();

	push(...items: ValidationError[]): number {
		const result = super.push(...items);
		this.changed$.next();
		return result;
	}

	splice(start: number, deleteCount?: number, ...items: ValidationError[]): ValidationError[] {
		const result = super.splice(start, deleteCount!, ...items);
		this.changed$.next();
		return result;
	}
}

export interface ValidationError {
	field: string;
	property: string;
	message: ValidationMessage;
	pattern: string;
}

export interface ValidationMessage {
	message: string;
	interpolation?: Record<string, any>;
}

export class ControlError implements ValidationError {
	constructor(
		private _field: string,
		private _property: string,
		private _message: ValidationMessage,
		private _pattern: string,
		private _control: any
	) {}

	public get field() {
		return this._field;
	}

	public get property() {
		return this._property;
	}

	public get message() {
		return this._message;
	}

	public get pattern() {
		return this._pattern;
	}

	public detectErrors() {
		this._control.markAsTouched();
	}

	public forceValidation() {
		this._control.forceValidation();
	}
}
